import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cng-agent-view-planning',
  templateUrl: 'agent-view-planning.component.html',
  styleUrls: ['./agent-view-planning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentViewPlanningComponent {}
